import { useEffect, useState } from "react";
import Arrows from "../components/arrows/Arrows";
import Loading from "../components/loading/Loading";
import Logo from "../components/logo/Logo";
import Motion from "../components/motion";
import PostBox from "../components/postBox/PostBox";
import ThirdLine from "../components/thirdLine/ThirdLine";
import { useCategories } from "../providers/Categories";
import { usePosts } from "../providers/Posts";
import { ContainerInitial } from "../styles/style";

const InitialPage = () => {
  const { categoriesLoad } = useCategories();
  const { firstLoad, setFirstLoad } = usePosts();
  const [load, setLoad] = useState(false);
  const [reLoad, setReload] = useState(true);

  setTimeout(() => {
    setLoad(true);
    setFirstLoad(true);
  }, 4000);

  const handleResize = () => {
    setReload(false);
    setTimeout(() => setReload(true), 1000);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {categoriesLoad ? (
        <Loading />
      ) : (
        <>
          <Logo />
          <Motion>
            <ContainerInitial>
              <ThirdLine />
            </ContainerInitial>
            {load || (firstLoad && reLoad) ? <Arrows /> : <></>}
          </Motion>
          <PostBox />
        </>
      )}
    </>
  );
};

export default InitialPage;
